module.exports = __webpack_public_path__ + "img/ignis-glx-gris-acero.7dacb9be.png";